<script>
  import { fly } from "svelte/transition";
  import { getSizedImageUrl } from "@shopify/theme-images";

  import TextContainer from "./TextContainer.svelte";
  import HeadingContainer from "./HeadingContainer.svelte";
  import Arrow from "./Arrow.svelte";

  export let menuItems = {};
  export let openSearchDialog = () => {};
  export let featuredProduct = {};
  export let bottomLink = {};

  let openedCategories = [];
  let categories = menuItems.filter((category) => category.children.length > 0);

  function toggleCategory(categoryTitle) {
    const set = new Set(openedCategories);

    if (!set.has(categoryTitle)) {
      set.add(categoryTitle);
    } else {
      set.delete(categoryTitle);
    }
    openedCategories = Array.from(set);
  }
</script>

<div
  class="tw-border-0 tw-border-t tw-border-solid tw-border-gray-200 tw-absolute tw-w-full tw-top-12 tw-left-0 tw-bg-white tw-z-20"
  in:fly={{ y: -10, duration: 200 }}
  out:fly={{ y: -10, duration: 200 }}
>
  <div class="tw-w-full tw-mx-auto">
    <div class="tw-px-4 tw-overflow-y-auto max-h">
      <div
        class="tw-mt-4 tw-flex tw-flex-col tw-cursor-default tw-text-left tw-whitespace-normal"
      >
        <div
          class="tw-cursor-pointer tw-text-gray-200"
          on:click|stopPropagation={() => openSearchDialog()}
        >
          <img
            loading="eager"
            width={22}
            height={22}
            src="//cdn.shopify.com/s/files/1/0114/4120/9408/t/177/assets/Search.svg?v=10008855831397490932"
            alt="search"
          />
        </div>
        <hr class="tw-w-full tw-mb-8" />
        <div class="tw-col-span-4 tw-flex-grow tw-flex tw-items-center tw-mb-4">
          <a
            href={bottomLink.url}
            class="tw-underline tw-cursor-pointer hover:tw-text-green-400"
          >
            <HeadingContainer text={bottomLink.text} />
          </a>
        </div>
        {#each categories as category}
          <div>
            <div
              class="tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-mb-4 tw-py-2 tw-border-0 tw-border-t tw-border-gray-200 tw-border-solid"
              on:click|stopPropagation={() => toggleCategory(category.title)}
            >
              <HeadingContainer text={category.title} />
              <Arrow isUp={openedCategories.includes(category.title)} />
            </div>
            {#if openedCategories.includes(category.title)}
              <div
                class="tw-mb-4"
                in:fly={{ y: -50, duration: 200 }}
                out:fly={{ y: -50, duration: 200 }}
              >
                {#each category.children as menuItem}
                  <div
                    class="tw-text-xs tw-uppercase tw-font-sans tw-font-medium tw-tracking-widest tw-leading-tight tw-py-2 tw-mb-2 tw-max-w-full"
                  >
                    <a
                      href={menuItem.url}
                      class="tw-cursor-pointer hover:tw-text-green-400"
                      ><TextContainer text={menuItem.title} /></a
                    >
                  </div>
                {/each}
              </div>
            {/if}
          </div>
        {/each}
        <a href={featuredProduct.ctaUrl} class="tw-text-center">
          <img
            loading="eager"
            class="tw-w-full tw-max-w-xl"
            src={getSizedImageUrl(featuredProduct.imageSrc, "350x")}
            alt={featuredProduct.label}
          />
          <div
            class="tw-col-span-2 tw-w-full tw-flex-grow tw-flex tw-items-center tw-justify-between tw-text-xs tw-uppercase tw-font-medium tw-tracking-widest tw-leading-tight tw-font-sans tw-mt-4"
          >
            <div class="tw-mr-2">
              {featuredProduct.label}
            </div>
            <div
              class="tw-block tw-flex tw-flex-row tw-items-center tw-justify-center tw-cursor-pointer hover:tw-text-green-400"
            >
              <TextContainer text={featuredProduct.ctaText} />
              <img
                class="tw-border tw-border-black tw-border-solid tw-rounded-full tw-p-2 tw--mt-1 tw-ml-2"
                src="https://cdn.shopify.com/s/files/1/0114/4120/9408/files/arrow-right.svg?v=1602849460"
                alt="arrow"
              />
            </div>
          </div>
        </a>
        <div
          class="tw-mt-8 tw-w-full tw-flex tw-flex-row tw-items-center tw-justify-center"
        >
          <a
            class="tw-mx-1"
            target="_blank"
            title="Sheertex on TikTok"
            href="https://www.tiktok.com/@sheertex"
          >
            <img
              loading="eager"
              width={46}
              height={46}
              src="https://cdn.shopify.com/s/files/1/0114/4120/9408/files/TIK_TOK.png?v=1613526715"
              alt="TikTok"
            />
          </a>
          <a
            class="tw-mx-1"
            target="_blank"
            title="Sheertex on Facebook"
            href="https://www.facebook.com/sheertex/"
          >
            <img
              loading="eager"
              width={46}
              height={46}
              src="https://cdn.shopify.com/s/files/1/0114/4120/9408/files/FACEBOOK_af0f90db-4f5d-439b-bbe2-f6690b9d4159.svg?v=1602279857"
              alt="Facebook"
            />
          </a>
          <a
            class="tw-mx-1"
            target="_blank"
            title="Sheertex on Instagram"
            href="https://www.instagram.com/sheertex/"
          >
            <img
              loading="eager"
              width={46}
              height={46}
              src="https://cdn.shopify.com/s/files/1/0114/4120/9408/files/INSTAGRAM_0e2db6b1-60f7-4824-8ad0-c01f66b5d9e9.svg?v=1602279857"
              alt="Instagram"
            />
          </a>
          <a
            class="tw-mx-1"
            target="_blank"
            title="Sheertex on Twitter"
            href="https://twitter.com/SheertexLabs"
          >
            <img
              loading="eager"
              width={46}
              height={46}
              src="https://cdn.shopify.com/s/files/1/0114/4120/9408/files/TWITTER.svg?v=1616769901"
              alt="Twitter"
            />
          </a>
        </div>
        <div class="tw-w-full tw-flex tw-flex-grow tw-h-16" />
      </div>
    </div>
  </div>
</div>

<style>
  .max-h {
    max-height: calc(var(--vh, 1vh) * 100 - 150px);
  }
</style>
